<template>
  <div class="screen-pick">
    <div class="pick-list" v-scrollBar ref="pickList">
      <div v-show="pickDetail.status === 0" style="white-space: pre-wrap;">
        <div
          class="pick-item"
          v-for="(item,studentIndex) in pickDetail.students"
          :key="studentIndex"
        >
          <img class="student-headImg" :src="getImg(item.headImage)" alt="student" />
          <div class="student-name">
            <div>
              <span>{{item.userName}}</span>
            </div>
          </div>
          <div
            class="select-area"
            @mouseenter="showOrHideSelectList(studentIndex,true)"
            @mouseleave="showOrHideSelectList(studentIndex,false)"
          >
            <button class="select-btn" type="button" v-show="!item.isSelect">
              <span
                class="select-text"
                v-text="!item.score||item.score =='未评分'?$t('pick.setScore'):item.score"
              ></span>
              <span class="iconfont icon-sanjiao"></span>
            </button>
            <ul class="select-list" v-show="item.isSelect" v-scrollBar>
              <li
                v-for="(item,index) in 10"
                :key="index"
                :value="10-index"
                @click="remarkStu(studentIndex,10-index)"
              >{{ $t("grade.points", { n: 10 - index }) }}</li>
            </ul>
          </div>
          <i class="student-del iconfont icon-qiapianguanbi" @click="delStudent(item,studentIndex)"></i>
        </div>
        <div class="pick-item" v-for="(item,index) in selectedList" :key="'select-num' + index">
          <img class="student-headImg" :src="getImg(item.headImage)" alt="student" />
          <div class="student-name">
            <div>
              <span>{{item.userName}}</span>
            </div>
          </div>
        </div>
        <div class="pick-selected pick-item" v-if="!inSelected&&pickDetail.status === 0">
          <img class="student-headImg" src="../../common/img/undo.png" alt="student" />
          <div class="select-area" @mouseenter="showList" @mouseleave="hideList">
            <button class="select-btn">
              <span class="select-text">{{ $t("system.peopleOf", { n: selectedNum }) }}</span>
              <span class="iconfont icon-sanjiao"></span>
            </button>
            <ul class="pick-list select-num-list" v-if="selected" v-scrollBar>
              <li
                v-for="(item,index) in selectNum"
                :key="index"
                :value="selectNum-index"
                @click="remark(index+1)"
              >{{ $t("system.peopleOf", { n: index + 1 }) }}</li>
            </ul>
          </div>
          <button
            class="pick-sure"
            :disabled="selectedNum > 0 ? false : true"
            :class="selectedNum > 0 ? '' : 'disabled'"
            @click="pickSure"
          >{{ $t("pick.choosePeople") }}</button>
        </div>
      </div>
      <div v-show="pickDetail.status === 1">
        <div
          v-for="(student,index) in pickDetail.students"
          :key="'no-'+index"
          class="pick-item result-student-item"
          :class="showScoreSort(index)"
        >
          <p class="student-order" v-if="index<3">{{index+1}}</p>
          <img class="student-headImg" :src="getImg(student.headImage)" alt="student" />
          <div class="student-name" :title="student.userName">
            <div>
              <span>{{student.userName}}</span>
            </div>
          </div>
          <p class="student-score">{{student.score}}</p>
        </div>
      </div>
    </div>
    <s-dialog
      :dialogText="$t('system.remind')"
      :dialogMsg="dialogMsg"
      @sure="sure"
      v-if="pickModal"
    ></s-dialog>
  </div>
</template>

<script>
import EventHandler from "../../common/js/EventHandler";
import Sdialog from "../../common/components/dialog/dialog";
export default {
  name: "pick",
  data() {
    return {
      timer: null,
      choseTimer: null,
      pickDetail: {},
      studentDetail: {},
      selectNum: 10,
      selected: false,
      selectedNum: 0,
      selectedList: [],
      inSelected: false,
      dialogMsg: "",
      pickModal: false
    };
  },
  methods: {
    init() {
      let self = this;
      self.userId = self.common.getCookie("userId");
      self.activityId = self.common.getCookie("activityId");
      self.getDetail();
      self.getStudent();
      self.timer = setInterval(() => {
        self.getDetail();
        self.getStudent();
      }, 2000);
    },
    getDetail() {
      let self = this;
      let params = {
        userId: self.userId,
        id: self.activityId,
        roleId: 8
      };
      self.$http
        .get(self.baseURL1 + "/selectperson/getDetail", { params: params })
        .then(res => {
          let data = res.data;
          self.$emit("pushDetial", data);
          self.inSelected = false;
          self.pickDetail = data;
          if (self.choseTimer) {
            self.selectedList = [];
            clearInterval(self.choseTimer);
            self.choseTimer = null;
          }
        });
    },
    getStudent() {
      let self = this;
      let params = {
        userId: self.userId,
        id: self.activityId
      };
      self.$http
        .get(self.baseURL1 + "/selectperson/randomChoosePerson", {
          params: params
        })
        .then(res => {
          self.studentDetail = res.data;
        });
    },
    getImg(imgUrl) {
      return this.common.handleImg(imgUrl, this.rescourceURL);
    },
    showList() {
      this.selected = true;
    },
    hideList() {
      this.selected = false;
    },
    remark(num) {
      this.selectedNum = num;
      this.selected = false;
    },
    remarkStu: function(i, score) {
      let self = this;
      self.provisionalClear(true);
      self.pickDetail.students[i].score = score;
      self.pickDetail.students.splice(i, 1, self.pickDetail.students[i]);
      self.showOrHideSelectList(i, false);
      let data = {
        userIds: self.pickDetail.students[i].userId,
        id: self.activityId,
        score: score
      };
      self.$http
        .post(
          self.baseURL1 +
            `/selectperson/giveMark?userIds=${data.userIds}&id=${data.id}&score=${data.score}`
        )
        .then(res => {
          self.provisionalClear(false);
        });
    },
    pickSure() {
      if (this.selectedNum > this.studentDetail.choosableCount) {
        this.pickModal = true;
        this.dialogMsg = this.$t("pick.noAnswer", {
          num: this.studentDetail.choosableCount
        });
        return;
      }
      let self = this;
      this.inSelected = true;
      let tempArr = self.getRandomArrayElements(
        this.studentDetail.students,
        this.selectedNum
      );
      self.selectedList = tempArr;
      self.saveSelectedPerson(tempArr);
      self.choseTimer = setInterval(() => {
        self.selectedList = self.getRandomArrayElements(
          this.studentDetail.students,
          this.selectedNum
        );
      }, 20);
    },
    saveSelectedPerson(arr) {
      let self = this;
      let tempArr = [];
      for (let i = 0; i < arr.length; i++) {
        tempArr.push(arr[i].userId);
      }
      let data = {
        userIds: tempArr.join(","),
        id: this.activityId
      };
      self.$http
        .post(
          self.baseURL1 +
            `/selectperson/saveSelectedPerson?userIds=${data.userIds}&id=${data.id}`
        )
        .then(res => {
          self.provisionalClear(true);
          setTimeout(function() {
            self.selectedNum = 0;
            self.provisionalClear(false);
            self.getDetail();
            self.getStudent();
          }, 1000);
        });
    },
    getRandomArrayElements(arr, count) {
      let shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    delStudent(item, index) {
      let that = this;
      that.provisionalClear(true);
      that.pickDetail.students.splice(index, 1);
      let data = {
        userId: item.userId,
        id: that.activityId
      };
      that.$http
        .delete(
          that.baseURL1 +
            `/selectperson/deleteSelectedPerson?userId=${data.userId}&id=${data.id}`
        )
        .then(res => {
          that.getStudent();
          that.provisionalClear(false);
        });
    },
    showOrHideSelectList: function(i, v) {
      let self = this;
      self.provisionalClear(v);
      if (self.pickDetail.students[i].isSelect == undefined) {
        self.$set(self.pickDetail.students[i], "isSelect", v);
      } else {
        self.pickDetail.students[i].isSelect = v;
        self.pickDetail.students.splice(i, 1, self.pickDetail.students[i]);
      }
    },
    provisionalClear: function(isClear) {
      let self = this;
      clearInterval(self.timer);
      self.timer = null;
      if (!isClear) {
        self.timer = setInterval(() => {
          self.getDetail();
          self.getStudent();
        }, 2000);
      }
    },
    overPick() {
      this.getDetail();
    },
    showScoreSort: function(i) {
      switch (i) {
        case 0:
          return "first ranking";
          break;
        case 1:
          return "second ranking";
          break;
        case 2:
          return "third ranking";
          break;
        default:
          return "";
      }
    },
    sure() {
      this.pickModal = false;
    }
  },
  created: function() {
    var that = this;
    EventHandler.bindEvent("overPick", this.overPick);
    that.init();
    that.$nextTick(function() {
      that.$refs.pickList.style.height = window.innerHeight - 120 + "px";
    });
  },
  watch: {},
  computed: {},
  components: {
    "s-dialog": Sdialog
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    if (this.choseTimer) {
      clearInterval(this.choseTimer);
      this.choseTimer = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "pick.scss";
</style>



// WEBPACK FOOTER //
// src/components/pick/pick.vue